import { API_BASE_URL } from "@/config";

import { apiFetch } from "../apiFetch";
import type { CountryCodeResponse } from "./types";

async function getCountryCode(): Promise<CountryCodeResponse> {
  const resp = await apiFetch(`${API_BASE_URL}/geo/country-code`);
  if (!resp.ok) throw new Error(`Failed to get country code: ${resp.statusText}`);
  return resp.json();
}

export const apiGeo = {
  getCountryCode,
};
